import { DataPipeline, Util } from '@finley-technologies/finley-types';

import type { LockedMeshRun } from './UploadDrawerContent';

/** A version of the reporting date, as GetPipelineRunInputs returns it. */
export type ReportingDateRun = {
  pipelineRunId: string;
  fileVersion: number;
  isLatest: boolean;
  isStale: boolean;
};

/**
 * The run a drawer opened on one reportingDate is locked to: its latest version
 * when that is still on the latest graph, so missing files can join it (or it can
 * be run again); otherwise the date's next version, 1 when it has none.
 */
export const lockMeshRun = ({
  runs,
  meshDocumentMetadata,
  reportingDate,
}: {
  runs: ReportingDateRun[];
  meshDocumentMetadata: DataPipeline.MeshDocumentMetadata;
  reportingDate: Util.FullDateStr;
}): LockedMeshRun => {
  const latestRun = runs.find((run) => run.isLatest) ?? null;
  if (latestRun && !latestRun.isStale) {
    return {
      // the run is on the latest graph, so the latest mesh's artifact is its
      meshRunId: DataPipeline.generateMeshRunId({
        pipelineRunId: latestRun.pipelineRunId,
        meshArtifactId: DataPipeline.readMeshDocumentId(
          meshDocumentMetadata.meshDocumentId,
        ).meshArtifactId,
      }),
      meshRunParams: {
        meshDocumentMetadata,
        rdfv: { reportingDate, fileVersion: latestRun.fileVersion },
      },
    };
  }
  return {
    meshRunId: null,
    meshRunParams: {
      meshDocumentMetadata,
      rdfv: { reportingDate, fileVersion: (latestRun?.fileVersion ?? 0) + 1 },
    },
  };
};
